<template>
  <div class="container">
    <div class="nav-top ">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">文明聊天规范</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/更换.png" class="nav-img none" />
      </div>
    </div>
    <div class="content ub ub-ver">
      <h3>社区文明聊天规范</h3>
      <span class="sp">
        为维护小火柴平台健康生态秩序，更好的保障用户的社交体验，我们制定了《小火柴社区文明聊天规范》，小火柴用户的行为须严格遵守该规范，我们也将依据该规范规则对违规行为进行相应的处理。
      </span>
      <span class="sp">
        我们目前将消息中存在的下述行为定义为低俗骚扰行为，针对此类行为，我们会视行为性质及发生频次进行警告、禁言直至封禁处理。
      </span>
      <label>
        类型一：直接或暗示性的诱导语言
      </label>
      <span>
        描述：明确约x意图，或隐晦暗示对方想要线下约x
        例如：“想啪啪”，“想要你”，“我想找你约一晚”，“约你开房”，“可以床上运动么”，“可以约么，去酒店”...
      </span>
      <label>
        类型二：有偿约x 
      </label>
      <span>
        描述：明确提出可以给钱进行约x
      </span>
      <span>
        例如：“500一次约嘛？”，“见面给钱一千一次”，“约么？给钱”...
      </span>
      <label>
        类型三：色情淫秽内容
      </label>
      <span>
        描述：聊天中含有色情淫秽类词
      </span>
      <span>
        例如：“想摸摸”，“你叫床声音大么”，“做爱么”... 
      </span>
      <label>
        类型四：直接侮辱性语言
      </label>
      <span>
        描述：恶意人身攻击，辱骂类内容 例如：“你个臭三八”，“小贱货”，“垃圾贱人”...
      </span>
      <label>
        类型五：暴露图片 
      </label>
      <span>
        描述：裸露、露点、不雅性暗示动作
      </span>
      <span class="sp1">
        请在交友的同时注意要自己的社交礼仪，建设自己在平台的社交信用，这样也会给你带来更多的关注和互动。最后，希望你在礼貌交友的同时也能收获到到一个同样真诚的她（他）。
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    mounted() {
      this.init_page();
    },
    methods: {
      back() {
        this.$router.go(-1); //返回上一层
      },
      init_page(){
        
      }
    }
  };
</script>
<style lang="scss" scoped>
.container {
  background-color: #fff;
}
.content {
  padding: 0.5rem 0.8rem;
  .sp {
    margin-bottom: 1rem;
    font-size: 1rem;
    color: #333;
  }
  .sp1 {
    margin: 1rem 0;
    font-size: 1rem;
    color: #333;
  }
  span {
    font-size: 0.9rem;
    line-height: 1.5rem;
    color: #666;
  }
  label {
    margin-top: 1rem;
    font-size: 1rem;
    font-weight: bold;
    line-height: 1.5rem;
  }
}
</style>